import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from '../auth/components/ProtectedRoute';
import { publicRoutes } from './publicRoutes';
import { protectedRoutes } from './protectedRoutes';
import ErrorBoundary from '../components/ErrorBoundary';

// Wrap protected routes with ProtectedRoute component
const wrappedProtectedRoutes = protectedRoutes.map(route => ({
  ...route,
  element: <ProtectedRoute>{route.element}</ProtectedRoute>,
  errorElement: <ErrorBoundary />
}));

// Add error boundary to public routes
const wrappedPublicRoutes = publicRoutes.map(route => ({
  ...route,
  errorElement: <ErrorBoundary />
}));

// Combine public and protected routes
export const router = createBrowserRouter([
  ...wrappedPublicRoutes,
  ...wrappedProtectedRoutes
]);
